import { Box, Tooltip } from "@mui/material";
import { alpha } from "@mui/material/styles";

export type SegmentFill = "current" | "completed" | "empty";

type Props = {
  step: string;
  label: string;
  color: string;
  textColor: string;
  fill: SegmentFill;
  progressFraction: number | null;
  tooltipLines: string[];
};

export default function StatusSegment({
  step,
  label,
  color,
  textColor,
  fill,
  progressFraction,
  tooltipLines,
}: Props) {
  const progressPercent =
    progressFraction === null ? null : Math.round(progressFraction * 100);

  return (
    <Tooltip
      title={
        tooltipLines.length > 0
          ? tooltipLines.map((line) => <div key={line}>{line}</div>)
          : ""
      }
      placement="top"
      arrow
    >
      <Box
        data-testid={`lidar-upload-status.segment.${step}`}
        data-fill={fill}
        sx={{
          position: "relative",
          overflow: "hidden",
          px: 0.75,
          py: 0.5,
          bgcolor:
            fill === "current"
              ? color
              : fill === "completed"
                ? alpha(color, 0.45)
                : "action.hover",
          color:
            fill === "current"
              ? textColor
              : fill === "completed"
                ? "text.primary"
                : "text.secondary",
          fontSize: 11,
          fontWeight: fill === "current" ? 800 : 600,
          lineHeight: "14px",
          textAlign: "center",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          "& + &": {
            borderLeft: "1px solid rgba(255, 255, 255, 0.45)",
          },
        }}
      >
        {label}
        {progressPercent !== null && (
          <Box
            role="progressbar"
            aria-valuenow={progressPercent}
            aria-valuemin={0}
            aria-valuemax={100}
            data-testid={`lidar-upload-status.segment-progress.${step}`}
            sx={{
              position: "absolute",
              left: 0,
              bottom: 0,
              height: 3,
              width: `${progressPercent}%`,
              bgcolor: color,
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
}
